import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../Core/Link';
import Pagination from '../../Core/Pagination';
import Container from '../../Core/Container';
import GlobalSearch from '../../Custom/GlobalSearch';

export const StyledGlobalSearch = styled(GlobalSearch)`
  margin: 15px 0 35px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 40px 0 65px;
  }
`;

export const StyledContainer = styled(Container)`
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }
`;

export const SearchFilterWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  margin-bottom: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 60px;
  }
`;

export const SearchButton = styled.button`
  background-color: ${({ active }) =>
    active ? themeGet('colors.pc-red') : themeGet('colors.light-border-grey')};
  color: ${({ active }) =>
    active ? themeGet('colors.white') : themeGet('colors.main-text')};
  font-size: 14px;
  font-weight: ${themeGet('fontWeights.medium')};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 8px 5px;
  transition: all 300ms ease-in-out;

  &:first-child {
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
  }

  &:last-child {
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
  }

  &:hover,
  &:focus {
    background-color: ${themeGet('colors.pc-red')};
    color: ${themeGet('colors.white')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    /* padding: 10px; */
    padding: 8px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 10px 20px;
  }
`;

export const SearchTitle = styled.h1`
  margin-bottom: 30px;

  span {
    color: ${themeGet('colors.pc-red', '#E1251B')};
    font-size: inherit;
    font-weight: inherit;
    font-stretch: inherit;
    font-style: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 60px;
  }
`;

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  padding: 0px 15px 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 0px 30px 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 0px 70px 80px;
  }
`;

export const NoResultsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 40px 0 100px;
`;

export const NoResults = styled.p`
  font-size: 24px;
  font-weight: ${themeGet('fontWeights.medium')};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${themeGet('colors.secondary-text')};
`;

export const Results = styled.ul`
  && {
    margin-top: -20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    && {
      margin-top: -40px;
    }
  }
`;

export const Result = styled.li`
  border-bottom: 1px solid ${themeGet('colors.secondary-text')};
  padding: 20px 0;
  &:hover,
  &:focus {
    background-color: ${themeGet('colors.pc-pink')};
  }

  ul,
  ol {
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 40px 0;
  }
`;

export const ResultLink = styled(Link)`
  &:hover,
  &:focus {
    background-color: rgba(0, 160, 173, 0.12);
  }
`;

export const ResultTitle = styled.h2`
  font-size: 24px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  margin: 0 0 16px;
`;

export const ResultDescription = styled.p`
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin: 16px 0 20px;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 90px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 18px;
    line-height: 1.56;
  }
`;

export const ResultCategory = styled.p`
  font-size: 12px;
  font-weight: ${themeGet('fontWeights.medium')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin: 20px 0 0;
`;

export const StyledPagination = styled(Pagination)`
  margin-top: 60px;
`;
